export const IMG = {
  login: require("./login.jpg"),
  logo: require("./logo.png"),

  banner: require("./banner.jpg"),
  bus: require("./bus.png"),
  cak: require("./cak.png"),
  cam: require("./cam.png"),
  car: require("./car.png"),
  cat: require("./cat.png"),
  dress: require("./dress.png"),
  flw: require("./flw.png"),
  hall: require("./hall.png"),
  music: require("./music.png"),

  quote: require("./quote.png"),
  email: require("./email.png"),
  location: require("./location.png"),
  phone: require("./phone.png"),
  insta: require("./insta.png"),
  twitter: require("./twitter.png"),
  fb: require("./fb.png"),
};
